var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"FuseSearch_result pl-4 pr-3 py-1",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.$emit('select', {item: _vm.item})}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }